import React from 'react';
import {customTableCtor} from "../TableBase";

import './styles.scss';
import TableBaseStatic from "../TableBaseStatic";

const tableDisplayProps = {
  headerHeight: 45,
  rowHeight: 79,
  className: 'merchant-table'
};

export const TableMerchant = customTableCtor(tableDisplayProps);
export const TableStaticMerchant = (props) => (
  <TableBaseStatic
    displayProps={tableDisplayProps}
    {...props}
  />
);
